import React, { useState } from "react";
import { Modal, message, Button, Input, Radio } from "antd";

import BoxServe from "../../../ajax/api/index";
const { TextArea } = Input;
export default function StrategyModel(props) {
  const [loading, setLoading] = useState(false);

  const [limitStrategy, setLimitStrategy] = useState(1);

  const [bandwidth, setBandwidth] = useState("");

  const handleBandwidth = (e) => {
    setBandwidth(e.target.value || "");
  };

  const handleStrategySelect = (e) => {
    setLimitStrategy(Number(e.target.value) || null);
    // e.target.value != "2" ? setBandwidth("") : bandwidth;
    if (Number(e.target.value) === 2) {
      // 固定限速
      setBandwidth("");
    }
  };

  // 关闭弹框
  const onCancel = () => {
    setLimitStrategy(1);
    setBandwidth("");
    props.handleStrategyModelClose(false);
  };

  // 提交
  const handleSubmit = async () => {
    const deviceNoList = props.list?.join(",") || "";

    const params = {
      deviceNoList,
      bandwidth: bandwidth ? Number(bandwidth) : "",
      limitStrategy: limitStrategy ? Number(limitStrategy) : ""
    };

    if (String(limitStrategy) === "2" && bandwidth === "") {
      return message.warning("请输入固定限速");
    }
    try {
      setLoading(true);
      const { code, msg } = await BoxServe.updateLimitBandwidth(params).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setLimitStrategy(1);
        setBandwidth("");
        message.success(msg);
        setTimeout(() => {
          onCancel();
          props.getBusinessList("business"); // 列表需要重置选中
        }, 200);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
      console.log(error);
    }
  };
  return (
    <>
      <div className="business-switching pressure-measurement">
        <Modal title="设置盒子设备限速策略" width="1000px" className="pressure-model business-model" footer={null} open={props.open} onCancel={onCancel}>
          <div className="box">
            <span className="title">已选盒子编号</span>
            <div className="list ">
              {props.list?.map((item, index) => (
                <span key={index} className="list-item">
                  {item}
                </span>
              ))}
              <span className="list-item">等{props?.list?.length}个盒子</span>
            </div>
          </div>
          <div className="box">
            <Radio.Group onChange={handleStrategySelect} value={limitStrategy}>
              <Radio value={1}>无限制</Radio>
              <Radio value={2}>固定限速</Radio>
              <Radio value={3}>智能限速</Radio>
            </Radio.Group>

            {limitStrategy === 2 ? (
              <div style={{ width: "50%", marginTop: "20px" }}>
                <Input placeholder="请输入固定限速(M)" value={bandwidth} onChange={handleBandwidth} />
              </div>
            ) : (
              ""
            )}
          </div>

          <Button type="primary" className="box-btn" loading={loading} shape="round" size={"large"} onClick={handleSubmit}>
            确 定
          </Button>
        </Modal>
      </div>
    </>
  );
}
